import {Routes} from '@angular/router';
import {MainComponent} from './pages/main/main.component';
import {authGuard} from './core/guards/auth.guard';


export const routes: Routes = [
  {path: '', component: MainComponent},
  { path: 'signin', loadComponent: () => import('./pages/signin/signin.component').then(c => c.SigninComponent) },
  { path: 'signin/verify', loadComponent: () => import('./pages/signin-verify/signin-verify.component').then(c => c.SigninVerifyComponent) },
  { path: 'signin/find', loadComponent: () => import('./pages/account-find/account-find.component').then(c => c.AccountFindComponent) },
  { path: 'signup', loadComponent: () => import('./pages/signup/signup.component').then(c => c.SignupComponent) },

  { path: 'listings', loadComponent: () => import('./pages/listings/listings.component').then(c => c.ListingsComponent) },
  { path: 'map', loadComponent: () => import('./pages/map/map.component').then(c => c.MapComponent) },
  { path: 'properties/:id', loadComponent: () => import('./pages/property-detail/property-detail.component').then(c => c.PropertyDetailComponent) },
  { path: 'realestate', canActivate: [authGuard], loadComponent: () => import('./pages/realestate/realestate.component').then(c => c.RealEstateComponent) },
  { path: 'events', loadComponent: () => import('./pages/events/events.component').then(c => c.EventsComponent) },
  { path: 'about', loadComponent: () => import('./pages/about/about.component').then(c => c.AboutComponent) },

  // 디자인 랩 — apple-design 스킬 검토용 격리 라우트. 운영 페이지와 공유 코드 없음(app/lab 하위 완결).
  { path: 'lab/motion', loadComponent: () => import('./lab/pages/motion-lab.component').then(c => c.MotionLabComponent) },

  // mypage
  {
    path: 'my',
    canActivate: [authGuard],
    children: [
      { path: '', loadComponent: () => import('./pages/my/my.component').then(c => c.MyComponent) },
      { path: 'listings', loadComponent: () => import('./pages/my/listings/my-listings.component').then(c => c.MyListingsComponent) },
      { path: 'listings/:id', loadComponent: () => import('./pages/my/listings/my-listing-manage.component').then(c => c.MyListingManageComponent) },
      { path: 'info', loadComponent: () => import('./pages/my/info/my-info.component').then(c => c.MyInfoComponent) },
      { path: 'sns', loadComponent: () => import('./pages/my/sns/my-sns.component').then(c => c.MySnsComponent) },
      { path: 'purchase', data: { title: '결제내역' }, loadComponent: () => import('./pages/my/placeholder/my-placeholder.component').then(c => c.MyPlaceholderComponent) },
      { path: 'coupon', data: { title: '쿠폰함' }, loadComponent: () => import('./pages/my/placeholder/my-placeholder.component').then(c => c.MyPlaceholderComponent) }
    ]
  },

  // support
  { path: 'support/faq', loadComponent: () => import('./pages/support/faq/faq.component').then(c => c.FaqComponent) },
  { path: 'support/notice', loadComponent: () => import('./pages/support/notice/notice.component').then(c => c.NoticeComponent) },
  { path: 'support/inquiry', loadComponent: () => import('./pages/support/inquiry/inquiry.component').then(c => c.InquiryComponent) },
  { path: 'support/bug', loadComponent: () => import('./pages/support/bug/bug.component').then(c => c.BugComponent) },
  { path: 'support/feature', loadComponent: () => import('./pages/support/feature/feature.component').then(c => c.FeatureComponent) }
];
